import { Component, Injectable, Input ,ViewChild,inject , signal, runInInjectionContext, EventEmitter, Output } from '@angular/core';
import { AlertComponent } from '../../alert/alert.component';
import { Location } from '@angular/common';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { Button } from '../../button/button.component';
import { Titledescription } from '../../titledescription/titledescription.component';
import { Form } from '../../form/form.component';
import { Divider } from '../../divider/divider.component';
import { FormField } from '../../../../constants/form.constants';
import { ApiService } from '../../../../core/api.service';
import { Injector } from '@angular/core';
import { CardComponent } from '../../card/card.component';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-crud-create',
  imports: [Button,Titledescription,Form,Divider,CardComponent],
  templateUrl: './create.html',
  styleUrl: './create.scss'
})
export class CrudCreateComponent<T> {
  @Input() apiService!:ApiService<T>
  backUrl = signal('');
  @Input() fields :{[name: string]:FormField} =  {};
  @Input() title: string = ''
  @Input() description: string = ''
  @ViewChild('formGeneral') form!:Form;
  private alert = inject(AlertComponent);
  private activatedRoute = inject(ActivatedRoute);
  private location = inject(Location);
  private subscriptions: Subscription[] = [];
  @Output() selectFieldValueEmit = new EventEmitter<any>();
  model !: any
  constructor() {
    const urlSub = this.activatedRoute.url.subscribe((UrlSegment: UrlSegment[]) => {
      this.backUrl.set(UrlSegment[0].path);
    });
    this.subscriptions.push(urlSub);
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  ngOnInit(){
    // this.apiService.getById(Number(this.id())).subscribe((data)=>{
    //   this.model = data;
    //   this.form.form.patchValue(this.model)
    // })
  }
  submit(){
    const submitForm = this.form.onSubmit();
    if(submitForm){
      // Limpiar: convertir string vacío a null
      Object.keys(submitForm).forEach(key => {
        if (submitForm[key] === "") {
          submitForm[key] = null;
        }
      });
      // Conversión específica para establecimientos
      // const numericFields = ["distrito_id", "residencia"];
      // numericFields.forEach(field => {
      //   if (submitForm[field] !== undefined && submitForm[field] !== null && submitForm[field] !== "") {
      //     submitForm[field] = Number(submitForm[field]);
      //   }
      // });
      // Asegurar que los string sean string (no null), incluyendo modalidad
      const stringFields = ["m", "observacion"];
      stringFields.forEach(field => {
        if (submitForm[field] === null || submitForm[field] === undefined) {
          submitForm[field] = "";
        } else {
          submitForm[field] = String(submitForm[field]);
        }
      });
      this.alert.goBack = true;
      this.apiService.create(submitForm).subscribe({
        next: data => {
          this.alert.openAlert("success", "Guardado!");
          // Navegación solo la maneja el alert
        },
        error: err => {
          this.alert.openAlert("error", "Algo ocurrió")
        }
      })
    }
  }
  navigateToBack(){
    this.location.back();
  }
  clearField(fieldName: string) {
    if (this.form && this.form.form) {
      this.form.form.get(fieldName)?.setValue('');
    }
  }
  setFieldOptions(fieldName: string, options: any[]) {
    if (this.fields[fieldName]) {
      this.fields[fieldName].options = [...options];
      this.form.originalOptionsMap[fieldName] = [...options]; // Actualiza el mapa de opciones originales
      this.form.selectOptionsFiltered[fieldName] = [...options]; // Actualiza las opciones filtradas para que reflejen el cambio
    }
  }
}

